import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from './app/hooks';

import { BrowserRouter } from 'react-router-dom';
import createApi from './api';
import {
  //setBillingCodes,
  setCurrencies,
  setPrimaryCurrency,
  setDefaultPageSize,
  setUsers,
  setDateFormat,
  setDateTimeFormat,
  getFmsGlobal,
  getDefaultPageSize,
  setFmsGlobalBySg,
} from './globals';
import Modal from 'react-modal';
import OkButton from './uiControls/OkButton';
import localforage from 'localforage';

import { loginUser, logoutUser, reset } from './features/loginSlice';
import { changeOperation } from './features/operationSlice';
import { clearStorage } from './features/storageSlice';
import { resetListScreenSettings } from './features/listScreenSettingsSlice';

import AuthService from './security/AuthService';

import ApplicationLoading from './ApplicationLoading';
import Login from './Login';
import IfmsMain from './IfmsMain';
import { User, SystemSettings, SuntekSettings } from './ifmsTypes';

import ApplicationContext from './ApplicationContext';
import { JobNames } from './framework.core/JobNames';
import { ApiResult } from './framework.core/data/ApiResult';
import { SecurityGrant } from './framework.core/SecurityGrant';
import { ControlType } from './fms.core/modules/FmsSecurity';
import { FormType } from './fms.enum';
import AutoLogin from './AutoLogin';
import { setDefaultForMSetup } from './fms.data/modules/FmsModFunc';
import _ from 'lodash';

const authService = new AuthService();

const api = createApi();

/*
function createWelcomeMessage(userSession:User, systemSettings:SystemSettings) {
  if (!userSession || !systemSettings) {
    return "";
  }

  const welcomeMessage =
`
----------------------------
Suntek Systems - iFMS (v0.1)
----------------------------
   User session started for: ${userSession.email}
   Primary currency: ${systemSettings.primaryCurrency}

   Currency data: ${JSON.stringify(systemSettings.currencies)}
   Default list size: ${systemSettings.defaultPageSize}

----------------------------
`;
  return welcomeMessage;
}
*/

Modal.setAppElement('#root');

const ModalContentStyle:React.CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 10000
};
const ModalOverlayStyle:React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  zIndex: 999998
};


function workerFunction() {
  onmessage = (event) => {
    //console.log('worker.onmessage:', event.data);

    // live
    const autoLogoutTime = 1000 * 60 * 60 * 2;  // 1000ms * 60 (1m) * 60 (1h) * 2 (2h)
    const initAutoLogoutTime = (1000 * 60 * 60) + (1000 * 60 * 50);  // 1h + 50min
    const initAutoLogoutReaminTime = 600; // 1sec * 60 (1min) * 10 (10min)

    // test/debug
    // const autoLogoutTime = 1000 * 60 * 2; // 2min
    // const initAutoLogoutTime = 1000 * 60 ; // 1min
    // const initAutoLogoutReaminTime = 30; //30sec

    function nextInterval(counter: number) {
      // counter calc
      counter--;
      if (counter >= 0) {
        postMessage(['setAutoLogoutRemain', counter]);

        // next setting.
        const remainTimerId = setTimeout(function () {
          nextInterval(counter);       // repeat
        }, 1000)

        // for stay loggedin.
        postMessage(['setRemainTimerId', Number(remainTimerId)]);
      }
    }

    switch (event.data[0]) {
      case 'setAutoLogoutTimer':
        clearTimeout(event.data[1]);  //prev timer clear

        let lastAction = Date.now();

        const timerId = setTimeout(() => {
          let now = Date.now();
          let delta = (lastAction + autoLogoutTime) - now;
          let delta2 = (lastAction + autoLogoutTime + initAutoLogoutReaminTime) - now; // last action + 2h + 10m - now
          //console.log('worker.onmessage delta:', lastAction, now, delta, delta2);

          if(delta2 < 0){
            // fire immediately logoff
            postMessage(['setAutoLogoutRemain', 9999]);
            postMessage(['setAutoLogoutRemain', 0]);
          } else 
          if (delta > 0) {
            clearTimeout(timerId);
            const timerId2 =  setTimeout(() => { 
              postMessage(['fireLogoutReaminTimer']); 
            }, delta);
            postMessage(['setTimerId', Number(timerId2)]);
          } else {
            postMessage(['fireLogoutReaminTimer']);
          }
        }, initAutoLogoutTime);

        postMessage(['setTimerId', Number(timerId)]);
        break;

      case 'createInterval':
        nextInterval(initAutoLogoutReaminTime);
        break;
      case 'clearTimeout':
        clearTimeout(event.data[1]);  //prev timer clear
        break;

      case 'getAutoLogoutRemainInit':
        postMessage(['setAutoLogoutRemain', initAutoLogoutReaminTime])
        break;
    }
  };
}

function App() {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [userBranchMissingDialog, setUserBranchMissingDialog] = useState<boolean>(false);
  const [authenticateDialog, setAuthenticateDialog] = useState<boolean>(false);
  const [authenticateMsg, setAuthenticateMsg] = useState<string>('');
  const [systemSettings, _setSystemSettings] = useState<SystemSettings>();
  const [suntekSettings, setSuntekSettings] = useState<SuntekSettings>(); //<pt211201>
  const [securityGrants, setSecurityGrants] = useState<SecurityGrant[]>();
  const [securityControls, setSecurityControls] = useState<Record<string, ControlType[]>>();
  //const [journalType, _setJournalType] = useState(0);
  const [appInfoAreaContent, setAppInfoAreaContent] = useState('none');
  const [useDarkMode, setUseDarkMode] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState('W');
  const [appInfoAreaDrawerHeight, setAppInfoAreaDrawerHeight] = useState(0);
  const userState = useAppSelector(state => state.user);
  const user = userState.user;
 //move to Memo & Log list
 const [myMemoTaskReminder, setMyMemoTaskReminder] = useState(false);
 const [myMemoId, setMyMemoId] = useState<number>(0);
  // for Suntek admin 2fa
  const [suntekAdmin2FAActive, setSuntekAdmin2FAActive] = useState<boolean>(false);
  const [suntekAdminVerify, setSuntekAdminVerify] = useState<boolean>(false);
  const [suntekAdminAuthFin, setSuntekAdminAuthFin] = useState<boolean>(false);
  const [suntekUser, setSuntekUser] = useState<User>();
  const [useCheckReminder, setUseCheckReminder] = useState(false);

  const dispatch = useAppDispatch();
  const isLoggedIn = !!user;
  let isSuntekAdmin = !!user?.isSuntekAdmin;

  let broadcastChannel = new BroadcastChannel('ifms-loginuser-channel');
  const anotherUserId = useRef<string>('');
  const loginUserId = useRef<string>('');
  
  const dataObj = '(' + workerFunction + ')();';
  const blob = new Blob([dataObj], { type: 'application/javascript' })
  const logoutWorker = new Worker(URL.createObjectURL(blob));

  function setSystemSettings(s : any){
    _setSystemSettings(s)
    setAppInfoAreaContent(s?.useMemoListByDefault ? 'memo' : 'none')
  }

  // function setJournalType(n: number) {
  //   _setJournalType(n);
  // }

  function initializeUserSession(userSession:User) {
    api.setAccessToken(userSession.accessToken);
    dispatch(loginUser(userSession));
    
    if (authService.isDifferentUserLogin(userSession.id ?? '')) {
      dispatch(reset());
      // dispatch(changeOperation(userSession.defaultOperation ?? 'Home'));
      dispatch(changeOperation('Home'));
    }

    authService.rememberLastLoginEmail(userSession ? userSession.id ?? '' : '');
    //authService.setUserLicProduct(userSession?.licProduct ?? '');

    isSuntekAdmin = userSession.isSuntekAdmin??false;
  }

  function adjustDateFormats(s:SystemSettings) {
    if (!s) {
      return;
    }

    if (!s.dateFormat) {
      s.dateFormat = 'MM-DD-YYYY';
      s.dateTimeFormat = 'MM-DD-YYYY HH:mm';
      s.datePlaceHolder = 'MM-DD-YYYY';
      s.dateTimePlaceHolder = 'MM-DD-YYYY HH:mm';
    } else {
      s.dateFormat = s.dateFormat.replace(/m/g, 'M').replace(/d/g, 'D').replace(/y/g, 'Y');
      s.dateTimeFormat = `${s.dateFormat} HH:mm`;
      s.datePlaceHolder = s.dateFormat;
      s.dateTimePlaceHolder = s.dateTimeFormat;
    }
  }

  async function loadSystemSettings() {
    const s = await api.getSystemSettings();
    adjustDateFormats(s);
    if (s && s.userBranchMissing && !isSuntekAdmin) {
      setUserBranchMissingDialog(true);
      return false;
    }
    setSystemSettings(s);
    //let user = authService.getUser() as User;
    //window.console.log(createWelcomeMessage(user, s));
    //window.console.log(s);
    setUseDarkMode(s?.useDarkMode ?? false);
    setBackgroundColor(!!s?.backgroundColor ? s?.backgroundColor : 'W');
    setCurrencies(!!s ? s.currencies : []);
    setPrimaryCurrency(!!s ? s.primaryCurrency : null);
    //<pt220816: portal - to avoid defaultPageSize = 0
    if(s?.defaultPageSize !== 0) {
      setDefaultPageSize(s?.defaultPageSize);
    } else {
      s.defaultPageSize = getDefaultPageSize();
    }
    //pt220816>
    setUsers(s?.users);
    setDateFormat(s.dateFormat);
    setDateTimeFormat(s.dateTimeFormat);

    // user grent setting
    setSecurityGrants(s?.securityGrants);
    setFmsGlobalBySg(s?.securityGrants, isSuntekAdmin);

    
    return true;
  }

  /**
   * pt211201
   */
  async function loadSuntekSettings() {
    const ss: SuntekSettings = {
      accounting: null,
      company: null,
      compliance: null,
      oceanAir: null,
      server: null,
      edi: null,
      myCompany: null,
      myEvent: null,
      general: null,
    }

    let apiResult: ApiResult<any> = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'SuntekCompany' });
    if (apiResult?.success) ss.company = apiResult.result;

    //await api.getSettingsSuntekSettingsCompany();
    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'OceanAir' });
    if (apiResult?.success) ss.oceanAir = apiResult.result;

    //= await api.getSettingsSuntekSettingsOceanAir();
    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'Accounting' });
    if (apiResult?.success) ss.accounting = setDefaultForMSetup(apiResult.result);

    //await api.getSettingsSuntekSettingsAccounting();
    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'MyCompany' });
    if (apiResult?.success) ss.myCompany = apiResult.result;

    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'Compliance' });
    if (apiResult?.success) ss.compliance = apiResult.result;

    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'EDI' });
    if (apiResult?.success) ss.edi = apiResult.result;

    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'Server' });
    if (apiResult?.success) ss.server = apiResult.result;

    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'MyEvent'});
    if (apiResult?.success) ss.myEvent = apiResult.result;

    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'General'});
    if (apiResult?.success) ss.general = apiResult.result;

    apiResult = await api.getJobDetail(JobNames.SystemSetup, { entityName: 'Charge'});
    if (apiResult?.success) ss.charge = apiResult.result;

    setSuntekSettings(ss);

    // fmsGlobal
    const fmsGlobal = getFmsGlobal();
    fmsGlobal.AcmeID = ss.company?.companyId;
    fmsGlobal.AcmeID3 = fmsGlobal.AcmeID?.substring(0, 3);
    fmsGlobal.AcmeID4 = fmsGlobal.AcmeID?.substring(0, 4);

    fmsGlobal.AgentGLNo = ss.myCompany?.agentGLNo;
    fmsGlobal.ARGLNo = ss.myCompany?.arglNo;
    fmsGlobal.APGLNo = ss.myCompany?.apglNo;
    fmsGlobal.IssuePlace = ss.myCompany?.issuePlace;
    fmsGlobal.HeadType = ss.myCompany?.headType;
    fmsGlobal.UseKorVat = ss.company?.currency === 'KRW';
    fmsGlobal.EarningGLNo = ss.myCompany?.earningGLNo;
    fmsGlobal.AGR1 = ss.myCompany?.agR1;
    fmsGlobal.AGR2 = ss.myCompany?.agR2;
    fmsGlobal.AGR3 = ss.myCompany?.agR3;
    fmsGlobal.HawbPSize = ss.myCompany?.hawbPSize;
    fmsGlobal.BlRemarks = ss.myCompany?.blRemarks;
    fmsGlobal.FCountry = ss.myCompany?.fCountry;
    fmsGlobal.OohOfrtCode = ss.myCompany?.oohOfrtCode;
    fmsGlobal.OihFrtChg = ss.myCompany?.oihFrtChg;
    fmsGlobal.OihChg = ss.myCompany?.oihChg;

    fmsGlobal.BrokerGroup = ss.myCompany?.brokerGroup;
    fmsGlobal.PsShareRatio = ss.myCompany?.psShareRatio;
    fmsGlobal.ShowChargesConfirmedAN = ss.myCompany?.showChargesConfirmedAN;
    fmsGlobal.UseABIDB = ss.myCompany?.useABIDB;
    fmsGlobal.ShareDocWIthABI = ss.myCompany?.shareDocWithABI;
    fmsGlobal.EnableSTKMemo = ss.myCompany?.enableSTKMemo;
    fmsGlobal.UseITNew = ss.myCompany?.a20FC10.substring(0, 1) === '1';
    fmsGlobal.CashInBankGLNo = ss.myCompany?.cashInBankGLNo;
    fmsGlobal.SavingsGLNo = ss.myCompany?.savingsGLNo;
    fmsGlobal.OtherSavingsGLNo = ss.myCompany?.otherSavingsGLNo;
    fmsGlobal.CheckReceivableGLNo = ss.myCompany?.checkReceivableGLNo;
    fmsGlobal.CheckPayableGLNo = ss.myCompany?.checkPayableGLNo;

    fmsGlobal.AgentAPGLNo = ss.myCompany?.agentAPGLNo;
    fmsGlobal.PayGLNo = ss.myCompany?.payGLNo;
    fmsGlobal.RcvGLNo = ss.myCompany?.rcvGLNo;
    fmsGlobal.AdvPayGLNo = ss.myCompany?.advPayGLNo;
    fmsGlobal.AdvRecGLNo = ss.myCompany?.advRecGLNo;
    fmsGlobal.VatGLNo = ss.myCompany?.vatGLNo;
    fmsGlobal.VatRcvGLNo = ss.myCompany?.vatRcvGLNo;
    fmsGlobal.ShowAmend = ss.myCompany?.showAmend;
    fmsGlobal.ViewETA = ss.myCompany?.viewETA;

    fmsGlobal.CloseDate = ss.myCompany?.closeDate;

    fmsGlobal.PimsID = ss.server?.pimsId;
    fmsGlobal.PimsUserID = ss.server?.pimsUserID;
    fmsGlobal.PimsUserPwd = ss.server?.pimsUserPwd;

    fmsGlobal.ChargeFscAE = ss.myCompany?.chargeFscAE;
    fmsGlobal.ChargeSscAE = ss.myCompany?.chargeSscAE;
    fmsGlobal.ChargeTsaAE = ss.myCompany?.chargeTsaAE;
    fmsGlobal.ChargeHandlingCAE = ss.myCompany?.chargeHandlingCAE;

    fmsGlobal.AmsMode = 'AMS/ACI';
    if (ss.compliance?.amsEnable || ss.compliance?.amsEnableAll) {
      if (!_.isEmpty(ss.compliance.amsId1) || !_.isEmpty(ss.compliance.amsId2) || !_.isEmpty(ss.compliance.amsId3)) {
        let apiResult = await api.getManifestProducts(ss.compliance.amsId1, ss.compliance.amsId2, ss.compliance.amsId3, ss.compliance.amsUseeManifest);
        if (apiResult?.success) {
          switch (apiResult.result) {
            case 1: fmsGlobal.AmsMode = 'AMS'; break;
            case 2: fmsGlobal.AmsMode = 'ACI'; break;
            case 3: fmsGlobal.AmsMode = 'ALL'; break;
          }
        }
      }
    }

    let isIntnl = ss.company?.country !== 'U.S.';
    if (isIntnl) fmsGlobal.CashierRelease = false;
    else fmsGlobal.CashierRelease = true;

    return true;
  }


  const detectPlatform = () => {
    let osName = "Unknown OS";
    let browser = null;
    let version = null;
    let userAgent = window.navigator.userAgent;

    if (userAgent) {
      const { isArray } = Array;
      const ua = userAgent.toLowerCase().replace(/^mozilla\/\d\.\d\W/, '')

      // Determine the operating system.
      if (userAgent.indexOf("Win") !== -1) osName = "Windows";
      if (userAgent.indexOf("Mac") !== -1) osName = "MacOS";
      if (userAgent.indexOf("Linux") !== -1) osName = "Linux";
      if (userAgent.indexOf("X11") !== -1) osName = "UNIX";
      if (userAgent.indexOf("Liunx") !== -1) osName = "Liunx";

      if (userAgent.indexOf("Android") !== -1) osName = "Android";
      if (userAgent.indexOf("like Mac") !== -1) osName = "iOS";

      // Extract browser and version information.
      const browserTest = ua.match(/(\w+)\/(\d+\.\d+(?:\.\d+)?(?:\.\d+)?)/g)
      const safariVersion = ua.match(/version\/(\d+(\.\d+)*)/)
      const saVersion = isArray(safariVersion) ? safariVersion[1] : null
      const browserOffset = browserTest && (browserTest.length > 2 && !(/^(ver|cri|gec)/.test(browserTest[1])) ? 1 : 0)
      const browserResult = browserTest && browserTest[browserTest.length - 1 - (browserOffset || 0)].split('/')
      browser = browserResult && browserResult[0];
      version = saVersion ? saVersion : browserResult && browserResult[1]

      // Check specifically for Edge
      if (ua.includes('edg/')) {
        const edgeMatch = ua.match(/edg\/(\d+\.\d+)/);
        browser = 'edge';
        version = edgeMatch && edgeMatch[1];
      }
    }

    return { browserInfo: `${osName} / ${browser??''} / ${version??''}` };
  }

  async function authenticateAsync() {

     if (process.env.NODE_ENV !== 'production') {
      return true;
    }

    //get user browser info.
    let info = detectPlatform();

    let result:string = await api.authenticate(info);

    if (!result) return false;

    var msg = '';
    switch (result.toString()) {
      case '100':
        break;
      case '105':
        msg = `Authentication has failed due to invalid subscription ID temporarily.
Please enter another login ID again or contact Suntek Systems Inc. ${getFmsGlobal().SuntekPhone}
iFMS will now terminate. (Ref# ${getFmsGlobal().SuntekPhone})`;
        break;

      case '106':
//already login
//         msg = `Someone has already logged in with the same user ID.
// Please use another valid user ID or contact your company's administrator to login.
// iFMS will now terminate. (Ref# ${result})`;
        break;
      case '200':
      case '204':
        //version msssage
        break;
      case '500':
        //mac address
        break;
      case '700':
        //db name
        break;

      default:    // 666 or 446
        msg = `Authentication has failed. Please contact Suntek Systems Inc. ${getFmsGlobal().SuntekPhone}
iFMS will now terminate. (Ref# ${result})`;
        break;
    }

    if (msg || ['200', '204'].indexOf(result) >= 0) {
      setAuthenticateMsg(msg);
      setAuthenticateDialog(true);
      return false;
    }

    return true;
  }

  function applySystemSettingsChange(change: Partial<SystemSettings>) {
    _setSystemSettings((prevSettings) => {
      const newSettings = { ...prevSettings, ...change };
      return newSettings;
    });
  }

  function applySuntekSettingsChange(change: Partial<SuntekSettings>) {
    if (suntekSettings) {
      // Should always be true for correctly loaded application
      setSuntekSettings({...suntekSettings, ...change});
    }
  }

  
  function applySecurityControlChange(jobname: string, change: ControlType[]) {
      setSecurityControls({...securityControls, ...{[jobname] : change} });
  }

  function getControlDisableBySecurity(jobName: string, conName: string, formType: FormType): boolean {
    let fromTypeStr = '';
    let result = false;
    if (formType === FormType.ModeAdd || formType === FormType.ModeCopy) {
      fromTypeStr = '_Add';
    } else if (formType === FormType.ModeEdit) {
      fromTypeStr = '_Edit';
    }

    if (securityControls) {
      if (!securityControls[jobName]) return false;

      let dicSecCntr = securityControls[jobName];

      dicSecCntr.forEach(secCntr => {
        if (securityGrants && securityGrants.find(g => g.securityTaskCode === secCntr.secCntr + fromTypeStr)) {
          let arrSecCntr = secCntr.contName.split('|');
          if (conName?.toUpperCase() === arrSecCntr[0]?.toUpperCase()) result = true;

          // const cont = document.getElementById(arrSecCntr[0]);
          // if (cont)  return true;// cont.setAttribute('disabled', 'disabled');
        }
      });
    }

    return result;
  }

  //<pt220911: Donot use this billing code loading>
  // async function loadBillingCodes() {
  //   const search = {
  //     general1: null,
  //     generalText1: null,
  //     general2: 'inactive',
  //     generalText2: 'false',
  //     orderBy: 'code',
  //     orderByAscending: true,
  //   };

  //   const apiResult = await api.getCodesBillingCodes(search);
  //   if (apiResult && apiResult.data) {
  //     setBillingCodes(apiResult.data);
  //   }
  // }

  async function initialize() {
    const systemSettingsValid = await loadSystemSettings();
    if (!systemSettingsValid) {
      return;
    }

    //<pt211201
    const suntekSettingsValid = await loadSuntekSettings();
    if(!suntekSettingsValid) return;
    //pt211201>

    const authenticateValid = await authenticateAsync();
    if (!authenticateValid) {
      return;
    }
    
    //await loadBillingCodes();
    setLoaded(true);
  }

  useEffect(() => {
    window.addEventListener('beforeunload', (e) => {
      broadcastChannel.removeEventListener('message', bcMessageHandler2);

      // login page. ignore confirm.
      if(window.location.pathname === '/' || window.name?.indexOf('ifmssub') > -1){ 
        return;
      }

      e.preventDefault();
      e.returnValue = true;
    });

    if(broadcastChannel){
      broadcastChannel.addEventListener('message', bcMessageHandler2);
    }

  }, []);

  useEffect(() => {
    if (authService.isAuthenticated()) {
      initializeUserSession(authService.getUser());
      initialize();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);


  useEffect(() => {
    if (suntekUser && suntekAdminAuthFin) {
      initializeUserSession(suntekUser);
      initialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suntekAdminAuthFin]);

  async function purgeLocalStorage() {
    const keys = await localforage.keys();

    const toDelete:Array<string> = [];
    keys.forEach(k => {
      toDelete.push(k);
    });

    for (let i = 0; i < toDelete.length; ++i) {
      await localforage.removeItem(toDelete[i]);
    }
  }

  async function forceLogout() {
    setUserBranchMissingDialog(false);
    setAuthenticateMsg('');
    setAuthenticateDialog(false);

    await purgeLocalStorage();

    dispatch(logoutUser());
    dispatch(clearStorage());
    dispatch(resetListScreenSettings());

    setLoaded(false);
  }

  async function doLoginUser(username:string, password:string, rememberMe:boolean, urlPrefix:string) {
    const apiResult = await api.login(username, password, urlPrefix);

    if (apiResult && apiResult.success) {
      loginUserId.current = username.toLowerCase();

      if (apiResult.user.branchMissing) {
        setUserBranchMissingDialog(true);
        return;
      }

      //<221006.dwshin. comment out. / 'remember me' uncheck when logging in. Problem going to the login page when the page is refreshed.
      //<pt231217: Donot remember for suntekadmin>
      if (rememberMe && !apiResult.user.isSuntekAdmin)  {
        authService.setUser(apiResult.user);
      }

      //<pt250417: production인 경우에만 Authenticator 적용>
      if (process.env.NODE_ENV !== 'production' // && apiResult.user.isSuntekAdmin
        ) {
        initializeUserSession(apiResult.user);
        await initialize();
      } else {
        api.setAccessToken(apiResult.user.accessToken);
        suntekAdmin2FAStart(apiResult.user);
      }
    }

    return apiResult;
  }

  async function suntekAdmin2FAStart(user: any) {
    // check user enable 2FA.
    // if disabled. show guide.
    setSuntekUser(user);
    setSuntekAdminAuthFin(false);
    //console.log(`suntekAdmin2FAStart`, user);

    if(!user.twoFactorEnabled){
      setSuntekAdmin2FAActive(true);
      const focusElement = document.getElementById('verifycode');
      if (focusElement) {
        focusElement.focus();
      }
    }else{
      setSuntekAdminVerify(true);
      const focusElement = document.getElementById('authcode');
      if (focusElement) {
        focusElement.focus();
      }
    }
  }

  async function do2FAActive(username:string, password:string, code: string){
    const apiResult = await api.active2FA(username, password, code);

    if(apiResult && apiResult.success){
      setSuntekAdmin2FAActive(false);
      setSuntekAdminAuthFin(true);
      return '';
    } else {
      // error msg display
      return apiResult.result;
    }
  }

  async function doSuntekAdminAuth(username:string, password:string, code: string){
    const apiResult = await api.suntekAdminAuth(username, password, code);

    if (apiResult && apiResult.success) {
      setSuntekAdminVerify(false);
      setSuntekAdminAuthFin(true);
      return '';
    } else {
      // error msg display
      return apiResult.result;
    }
  }

  function focusPassword() {
    setTimeout(() => {
      const password = document.getElementById('password') as HTMLInputElement;
      if (password) {
        password.focus();
      }
    }, 500);
  }

  async function on2FAActiveCancel() {
    setSuntekAdmin2FAActive(false);
    focusPassword();
    loginUserId.current = '';
  }

  async function onSuntekAdminAuthCancel() {
    setSuntekAdminVerify(false);
    focusPassword();
    loginUserId.current = '';
  }
  
  async function autoLoginCall() {
    const apiResult =  await api.autologin(window.location.search);
    if(apiResult){
      initializeUserSession(apiResult);
      await initialize();
      return;
    }
    else{
      // move to login
      window.location.href ='/';
    }
  }

  async function bcMessageHandler2(e:any) {
    let currentLoginId = loginUserId.current.toLowerCase();
    //console.log(`get msg broadcastchannel-login`, e.data.Target, e.data.Value, currentLoginId);

    if(e.data.Target === 'getLoginInfo' && e.data.Value === currentLoginId){
        broadcastChannel.postMessage({ Target: 'updateLoginInfo', Value:currentLoginId });
    }else if (e.data.Target === 'updateLoginInfo'){
      anotherUserId.current = e.data.Value;
    }
  }

  async function fineOtherTabLogin(userid:string){
    let result = true;
    //<240801.dwshin. Suntek Admin ID Pattern Update
    //if(userid === getFmsGlobal().SUNTEK_ID)  return result;
    //if(userid === getFmsGlobal().SUNTEK_ID || userid.startsWith('@'))  return result;
    //240801.dwshin>
    
    userid = userid.toLocaleLowerCase();
    anotherUserId.current = '';
    broadcastChannel  = new BroadcastChannel('ifms-loginuser-channel');
    broadcastChannel.postMessage({ Target:'getLoginInfo', Value: userid });
    

    // check user name. 
    // wait bc message
    // if duplicate none. return true.
    // else return false.
 
    await new Promise(resolve => setTimeout(resolve, 500))
    .then(() => {
      if(anotherUserId.current === userid){
        result = false;
      }
    });

    return result;
  }

  if(window.location.pathname === '/autologin' && !loaded ){
    return (<AutoLogin autoLoginCall={autoLoginCall} />);
  }

  if (!isLoggedIn) {
    return (
      <Login onLogin={doLoginUser} fineOtherTabLogin={fineOtherTabLogin} 
      // Suntek Admin ID Pattern Update - 2FA Add
      suntekUser={suntekUser}
      suntekAdmin2FAActive={suntekAdmin2FAActive} do2FAActive={do2FAActive} on2FAActiveCancel={on2FAActiveCancel}
      suntekAdminVerify={suntekAdminVerify} doSuntekAdminAuth={doSuntekAdminAuth} onSuntekAdminAuthCancel={onSuntekAdminAuthCancel}
      />
    );
  }

  const applicationCtx = 
  !loaded
    ? <ApplicationLoading />
    : 
    (
      <ApplicationContext.Provider
        value={{
          api,
          user,
          systemSettings,
          setSystemSettings: applySystemSettingsChange,
          suntekSettings,   //<pt211201>
          setSuntekSettings: applySuntekSettingsChange,
          defaultPageSize: systemSettings?.defaultPageSize || 50,
          // journalType,
          // setJournalType,
          onLogout: () => {
            loginUserId.current = '';
            anotherUserId.current = '';
            setLoaded(false);
          },
          refreshSystemSettings: async () => {
            await loadSystemSettings()
          },
          securityGrants,
          appInfoAreaContent,
          setAppInfoAreaContent,
          useDarkMode,
          setUseDarkMode,
          backgroundColor,
          setBackgroundColor,
          appInfoAreaDrawerHeight,
          setAppInfoAreaDrawerHeight,
          securityControls,
          setSecurityControls: applySecurityControlChange,
          getControlDisableStatus: getControlDisableBySecurity,
          logoutWorker: logoutWorker,
          myMemoTaskReminder,
          setMyMemoTaskReminder,
          useCheckReminder,
          setUseCheckReminder,
          myMemoId,
          setMyMemoId,
        }}>
        <BrowserRouter>
          <IfmsMain />
        </BrowserRouter>
      </ApplicationContext.Provider>
    );
    

  return (
    <>
      {applicationCtx}
      <Modal
        isOpen={userBranchMissingDialog}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        contentLabel=""
        style={{
          overlay: ModalOverlayStyle,
          content: ModalContentStyle
        }}
      >
        <div>
          <p>Login User does not have Branch Info.(CR)<br />
          Please ask your Admin to setup Branch Info of User Property.</p>
        </div>
        <OkButton
          onOk={forceLogout}
        />
      </Modal>
      <Modal
        isOpen={authenticateDialog}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        contentLabel=""
        style={{
          overlay: ModalOverlayStyle,
          content: ModalContentStyle
        }}
      >
        <div>
          {authenticateMsg.split('\n').map((str, index) => <div key={`ifms5-app-msg-${index}`}>{str}<br/></div>)}
        </div>
        <OkButton
          onOk={forceLogout}
        />

      </Modal>
    </>
  );

  // const globalYesNoDialog = useAppSelector(state => state.globalYesNoDialog);
  // const dispatch = useAppDispatch();

  // const [ showGlobalYesNoDialog ] = useGlobalYesNoDialog();

  // const application = <div>Hello world</div>;

  // async function test() {
  //   const result = await showGlobalYesNoDialog(
  //     <p>Hello word</p>
  //   );
  //   window.console.log(result);
  // }

  // function close() {
  //   if (globalYesNoDialog.resolve) {
  //     globalYesNoDialog.resolve(true);
  //   }

  //   dispatch(hideGlobalYesNoDialog());
  // }

  // function resetState() {
  //   dispatch(reset());
  // }

  // return (
  //   <>
  //     {application}

  //     Show: {globalYesNoDialog.show ? 'true' : 'false'}
  //     <br />

  //     <button onClick={test}>Try me</button>
  //     <br />
  //     <br />
  //     <br />

  //     {globalYesNoDialog.show &&
  //       <button onClick={close}>Try me</button>
  //     }


  //     <br />
  //     <br />
  //     <ul />
  //     <button onClick={resetState}>Reset state</button>

  //   </>
  // );
}

export default App;
